import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuditLogViewer() {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { getToken } = useAdminAuth();

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/audit`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      setLogs(response.data.audit_logs);
    } catch (error) {
      console.error('Error fetching audit logs:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getActionBadge = (action) => {
    const styles = {
      create: 'bg-green-500/10 text-green-400',
      update: 'bg-blue-500/10 text-blue-400',
      delete: 'bg-red-500/10 text-red-400',
      approve: 'bg-purple-500/10 text-purple-400',
      reject: 'bg-orange-500/10 text-orange-400',
      suspend: 'bg-red-500/10 text-red-400',
      reactivate: 'bg-green-500/10 text-green-400',
    };
    return styles[action] || 'bg-gray-500/10 text-gray-400';
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Audit Log</h1>
        <p className="text-gray-400 mt-1">Registro completo de todas las acciones administrativas</p>
      </div>

      <div className="bg-gray-800 rounded-lg border border-gray-700 overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-500"></div>
          </div>
        ) : logs.length === 0 ? (
          <div className="text-center py-12">
            <h3 className="text-sm font-medium text-gray-400">No hay logs disponibles</h3>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-900/50">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Timestamp</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Admin</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Acción</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">Recurso</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase">ID Recurso</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {logs.map((log) => (
                  <tr key={log.id} className="hover:bg-gray-700/50">
                    <td className="px-6 py-4 text-sm text-gray-400">
                      {new Date(log.timestamp).toLocaleString('es-ES')}
                    </td>
                    <td className="px-6 py-4 text-white">
                      {log.admin_email}
                      <div className="text-xs text-gray-500">{log.admin_id}</div>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${getActionBadge(log.action)}`}>
                        {log.action}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-300">{log.resource_type}</td>
                    <td className="px-6 py-4 text-xs text-gray-500 font-mono">{log.resource_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
